import {Component, OnDestroy, OnInit} from '@angular/core';
import {BsModalRef} from "ngx-bootstrap";
import {NodeModel, INodeOptions, NodeOptionsObject} from "@app/workflow-common/diagram-view2/models/node.model";
import {Blocks} from "@app/workflow-common/services/Blocks";
import {InitialBlock} from "@app/workflow-common/services/DagSourceModel";
import {WorkflowhttpService} from "@app/workflow-common/services/workflowhttp.service";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {
    MenuItemsInterface,
    SidebarMetadataInterface,
    SidebarNavService
} from "@app/shared/cs-components/sidebar-nav/services/sidebar-nav.service";
import {TranslateService} from "@ngx-translate/core";
import {
    WorkflowDataInterface,
    WorkflowObservableService
} from "@app/workflow-common/services/workflow-observable.service";

@Component({
    selector: 'app-automation-setup',
    templateUrl: './automation-setup.component.html',
    styles: []
})
export class AutomationSetupComponent implements OnInit, OnDestroy {

    public onClose: Subject<any>;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    nodes: InitialBlock[];
    nodeOptions: INodeOptions;
    sidebarMetadata: SidebarMetadataInterface;
    currentActiveMenuItem: MenuItemsInterface = {id: "", status: undefined, title: "", visible: false};

    id: number = 0;
    title: string;
    objectName: string;
    settingsTypeId: number;
    screenName: string;
    isLoading: boolean = false;
    isNew: boolean = true;
    metadata: any = undefined;
    workflowData: WorkflowDataInterface = undefined;
    isDraftMode: boolean = undefined
    stepperStatus:any = {
        'basic_details': 'in_progress',
        'custom_automation': 'pending'
    };
    viewMode: string = 'form';

    constructor(
        public modalRef: BsModalRef,
        private _workflowService: WorkflowhttpService,
        public sidebarNavService: SidebarNavService,
        private translate: TranslateService,
        private _workflowObservableService: WorkflowObservableService
    ) { }

    async ngOnInit() {
        this.onClose = new Subject();
        if(!this.isNew && this.id > 0) {
            this.isLoading=true
            await this.getData();
            this.isLoading=false;

            this.stepperStatus = {
                basic_details: 'completed'
            }
            if(Object.keys(this.workflowData.dagSource).length === 0) {
                this.stepperStatus['custom_automation'] = 'in_progress';
            }
            else {
                this.stepperStatus['custom_automation'] = 'completed';
            }
        }
        this.setSidebarMeta(this.stepperStatus);
        this.sidebarNavService.setMetadata(this.sidebarMetadata);
        this._workflowObservableService.workflowData$
            .pipe( takeUntil ( this._unsubscribeAll ))
            .subscribe({
                next: (data: WorkflowDataInterface) => {
                    this.workflowData = data;
                }
        })
    }

    getData() {
        return new Promise( (resolve, reject) => {
            this._workflowService.getWorkflowData(
                this.id,
                'custom_automation'
            )
            .pipe(takeUntil( this._unsubscribeAll ))
            .subscribe( {
                next: (resp) => {
                    console.log('resp', resp);
                    if(resp.hasOwnProperty('workflowData')) {
                        this.workflowData = resp['workflowData'];
                        resolve(true);
                    }

                },
                error: (err) => {
                    console.error(err);
                    reject(false);
                }
            });
        })
    }

    setSidebarMeta(stepsStatus:any = undefined) {
        this.sidebarMetadata = {
            showProgressBar: true,
            items: [
                {
                    id: 'basic_details',
                    title: this.translate.instant('Basic.Details.Title'),
                    status: stepsStatus ? stepsStatus['basic_details'] : 'in_progress',
                    visible: true,

                },
                {
                    id: 'custom_automation',
                    title: this.translate.instant('Automation'),
                    status: stepsStatus ? stepsStatus['custom_automation'] :'pending',
                    visible: true
                },
            ]
        };
    }

    setCurrentActiveItem(e) {
        this.currentActiveMenuItem = e;
    }

    closeModal() {
        this.onClose.next(true)
        this.modalRef.hide();
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

}
